const yesNoBooleanMap = input => {
  switch (input?.toLowerCase()) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return input;
  }
};

export const filterYesNoFromBoolean = (rows, id, filterValue) =>
  rows.filter(row => row.values[id] === yesNoBooleanMap(filterValue));

// need this to remove custom filter from table filters when removed on UI
filterYesNoFromBoolean.autoRemove = value => !value;

/**
 * @name scrollbarWidth
 * @desc Provides the width of the browser scrollbar. See https://davidwalsh.name/detect-scrollbar-width
 * @return {number} The width of the scrollbar in pixels
 */
export const scrollbarWidth = () => {
  const scrollDiv = document.createElement('div');
  scrollDiv.setAttribute('style', 'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;');
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};
